import React from 'react';
import Style from '../../Styles/DashboardStyle.module.css';

const SelectInput = ({ label, id, value, onChange, options, title, errorMessage }) => (
    
    <div className={Style.group}>
        <label htmlFor={id}>{label}</label>
        <select className={Style.fromControl} id={id} name={id} value={value} onChange={onChange}>
            {options &&(
                <>
            <option value="">{title}</option>
           
            {options.map((option,i) => (
                // <option key={option.id} id={option.iso2 !=undefined?(option.iso2):(option.state_code)}  value={option._id}>{option.name}</option>
                <option id={option.id } key={option.id || i} value={option._id}>{option.name}</option>
            ))}
        </>)}
        </select>
        {errorMessage && <span className={`${Style.fieldValidationValid} ${Style.textDanger}`} data-valmsg-for={id} data-valmsg-replace="true">{errorMessage}</span>}
    </div>
);

export default SelectInput;